(function () {
  'use strict';

  /**
   * Formats a date string into a human-readable format.
   * @param {string} dateString - The date string to format.
   * @returns {string} - Formatted date string.
   */
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString(undefined, options);
  }

  /**
   * Updates the SKU display element.
   * @param {Object} variantData - The variant data object.
   */
  function updateSkuDisplay(variantData) {
    const skuDisplay = document.querySelector('.variant-sku');
    if (skuDisplay) {
      skuDisplay.innerHTML = `
        <span class="variant-sku" style="font-weight: 300; font-size: 1.1em">
          ${window.translations.sku_label}:
        </span>
        <span id="sku-value" style="font-weight: 500; font-size: 1.3em">
          ${variantData.sku || 'N/A'}
        </span>
      `;
    }
  }

  /**
   * Updates the inventory note based on variant availability.
   * @param {Object} variantData - The variant data object.
   */
  function updateInventoryNote(variantData) {
    const inventoryNote = document.querySelector('.inventoryNote');
    if (!inventoryNote) return;

    if (variantData.available) {
      if (variantData.inventory_quantity > 0 && variantData.inventory_quantity <= 10) {
        inventoryNote.textContent = window.translations.stock_few.replace('{{ count }}', variantData.inventory_quantity);
      } else if (variantData.inventory_quantity > 10) {
        inventoryNote.textContent = window.translations.stock_many;
      } else {
        inventoryNote.textContent = '';
      }
    } else {
      inventoryNote.textContent = window.translations.out_of_stock;
    }
  }

  /**
   * Updates the Add to Cart and Pre-order buttons.
   * @param {Object} variantData - The variant data object.
   */
  function updateCartButtons(variantData) {
    const addToCartButton = document.querySelector('[name="add"]');
    const preOrderButton = document.querySelector('[data-product-preorder]');
    if (!addToCartButton) return;

    let buttonText = '';
    if (variantData.inventory_quantity <= 0) {
      buttonText = window.translations.pre_order;
      addToCartButton.disabled = false;
      if (preOrderButton) preOrderButton.value = 'Pre-order';
    } else if (!variantData.available) {
      buttonText = window.translations.out_of_stock;
      addToCartButton.disabled = true;
      if (preOrderButton) preOrderButton.value = '';
    } else {
      buttonText = window.translations.add_to_cart;
      addToCartButton.disabled = false;
      if (preOrderButton) preOrderButton.value = '';
    }

    const addToCartText = addToCartButton.querySelector('[data-add-to-cart-text]');
    if (addToCartText) {
      addToCartText.textContent = buttonText;
    } else {
      addToCartButton.textContent = buttonText;
    }
  }

  /**
   * Updates the price display element.
   * @param {Object} variantData - The variant data object.
   */
  function updatePriceDisplay(variantData) {
    const priceDisplay = document.querySelector('[data-button-price]');
    if (priceDisplay && variantData.price) {
      priceDisplay.textContent = Shopify.formatMoney(variantData.price, "{{ amount_with_currency }}");
    }
  }

  /**
   * Updates the next delivery date display.
   * @param {Object} variantData - The variant data object.
   */
    function updateNextDeliveryDate(variantData) {
      const nextDeliveryDateContainer = document.getElementById('next-delivery-date-container');
      const dateElement = document.querySelector('.next-delivery-date-value');
    
      if (!nextDeliveryDateContainer || !dateElement) return;
    
      // Assuming 'productNextDeliveryDate' is a global variable set elsewhere with the product-level next delivery date
      const deliveryDate = window.productNextDeliveryDate;
    
      // Show the delivery date only when the variant is out of stock
      if (variantData.inventory_quantity <= 0 && deliveryDate && deliveryDate.trim() !== '') {
        nextDeliveryDateContainer.style.display = 'block';
        dateElement.textContent = formatDate(deliveryDate);
      } else {
        nextDeliveryDateContainer.style.display = 'none';
      }
    }



  /**
   * Updates the preorder lead time display.
   * @param {Object} variantData - The variant data object.
   */
  function updatePreorderLeadTime(variantData) {
    const preorderLeadtimeLabel = document.querySelector('#preorder-leadtime');
    if (!preorderLeadtimeLabel) return;

    if (variantData.preorder_leadtime && variantData.inventory_quantity <= 0 && variantData.is_preorder) {
      preorderLeadtimeLabel.style.display = 'block';
      preorderLeadtimeLabel.innerHTML = `
        <span class="preorder-leadtime-label" style="font-weight: 300; font-size: 1.1em">${window.translations.preorder_leadtime}:</span>
        <span class="preorder-leadtime-value" style="font-weight: 500; font-size: 1.1em">${variantData.preorder_leadtime}</span>
        <span class="preorder-leadtime-label" style="font-weight: 300; font-size: 1.1em">${window.translations.preorder_leadtime_days}</span>
      `;
    } else {
      preorderLeadtimeLabel.style.display = 'none';
      preorderLeadtimeLabel.innerHTML = '';
    }
  }

  /**
   * Main function to update all variant-related UI elements.
   * @param {Object|string} variant - The variant object or ID.
   */
  function updateAllVariantUI(variant) {
    if (!variant) return;

    const variantId = variant.id || variant;
    const variantData = window.variantData?.[variantId];
    if (!variantData) return;

    console.log('Variant Data:', variantData);
    console.log(window.variantData);

    updateSkuDisplay(variantData);
    updateInventoryNote(variantData);
    updateCartButtons(variantData);
    updatePriceDisplay(variantData);
    updateNextDeliveryDate(variantData);
    updatePreorderLeadTime(variantData);
  }

  // Event-based variant change
  document.addEventListener('theme:variant:change', function (event) {
    const variant = event.detail.variant;
    if (variant) updateAllVariantUI(variant);
  });

  // Fallback: Listen for select change
  document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.querySelector('[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateAllVariantUI(this.value);
      });

      // Initial load
      updateAllVariantUI(variantSelect.value);
    }

    console.log('✅ custom.js loaded and merged with variant-switcher.js');
  });
})();
